import { Regions } from "@enonic/react-components";
import { HdsFooter } from "./hds-footer";
import { HdsNavbar } from "./hds-navbar";
import { ChatbotButton } from "./chatbot";
import { Gtm } from "./gtm";

import "./hds-page.scss";

export const HdsPage = (props) => (
    <>
        <a href="#main-content" className="kp-skip-to-content-link">
            {props.skipToMainContentText}
        </a>
        {props.gtmId && <Gtm gtmId={props.gtmId} />}
        <HdsNavbar headerData={props.headerData} trackingUrl={props.trackingUrl} />
        <main role="main" id="main-content">
            <Regions {...props} classes="kp-main-region" />
        </main>
        <HdsFooter footerData={props.footerData} />
        {props.chatbot && <ChatbotButton chatbot={props.chatbot} language={props.language} />}
    </>
);
